import { FragmentOf, graphql, readFragment } from 'gql.tada'
import { toast } from 'react-toastify'
import { useMutation } from 'urql'

import IconPlus from '@/assets/icons/ic_logic-g-app_plus.svg'
import { Button } from '@/components/ui/button'
import { Maybe } from '@/utils/common-types'

interface Props {
  viewer: Maybe<FragmentOf<typeof AddEmptyPlayerButton_viewer>>
}

export const AddEmptyPlayerButton = (props: Props): JSX.Element => {
  const viewer = readFragment(AddEmptyPlayerButton_viewer, props.viewer)
  const onlySubscription =
    (viewer?.hasSubscription || viewer?.isFreeTrialUser) && !viewer?.hasCurriculumLicense
  const [_, createEmptyPlayer] = useMutation(EmptyPlayerCreateMutation)

  if (onlySubscription) return <></>

  const handleCreateEmptyPlayer = async () => {
    const { error, data } = await createEmptyPlayer({})

    if (error || data?.emptyPlayerCreate?.errors) {
      toast.error('プレイヤーの追加に失敗しました', {
        toastId: 'add-empty-player-failure',
        position: 'bottom-right',
      })
      return
    }

    toast.success('プレイヤーを追加しました.', {
      toastId: 'add-empty-player-success',
      position: 'bottom-right',
    })
  }

  return (
    <div className="mt-10 flex justify-center">
      <Button
        variant="outline"
        className="w-full max-w-[400px] disabled:border-none"
        onClick={handleCreateEmptyPlayer}
        disabled={!viewer?.canCreatePlayer}
      >
        <IconPlus className="mr-2 h-6 w-6" />
        プレイヤーを追加
      </Button>
    </div>
  )
}

export const AddEmptyPlayerButton_viewer = graphql(`
  fragment AddEmptyPlayerButton_viewer on User {
    id
    hasCurriculumLicense
    hasSubscription
    isFreeTrialUser
    canCreatePlayer
  }
`)

const EmptyPlayerCreateMutation = graphql(`
  mutation EmptyPlayerCreate {
    emptyPlayerCreate {
      errors {
        ... on UserDoesNotHaveCurriculumLicenseError {
          field
          message
        }
      }
      player {
        id
      }
    }
  }
`)
